import { useEffect, useState } from 'react';
import axios from 'axios';
import API_URL from '../config';

function ApplyHistory() {

  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    window.location.href = "/";
  }

  const [applications, setApplications] = useState([]);
  // eslint-disable-next-line
    useEffect(() => {
    fetchApplications();
    }, []);

  const fetchApplications = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/applications/user/${user.id}`
      );
      console.log("API response:", res.data);
      setApplications(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">

      {/* Navbar */}
      <div className="bg-white shadow-md px-6 py-4 flex justify-between">
        <h1 className="text-xl font-bold text-blue-600">My Applications</h1>

        <button
          onClick={() => window.location.href = "/dashboard"}
          className="bg-blue-500 text-white px-3 py-1 rounded"
        >
          Back
        </button>
      </div>

      {/* Content */}
      <div className="p-6">

        {applications.length === 0 ? (
          <p>No applications found</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

            {applications.map((app) => (
            <div
                key={app.id}
                className="bg-white p-5 rounded-xl shadow"
            >
                <h3 className="text-lg font-bold text-blue-600">
                {app.role}
                </h3>

                <p className="text-gray-600 mt-2">
                Location: {app.location}
                </p>

                <p className="text-gray-600">
                Salary: ₹{app.salary}
                </p>

                <p className="text-gray-600">
                Status: {app.status}
                </p>

                <p className="text-gray-500 text-sm mt-2">
                Applied On: {new Date(app.created_at).toLocaleDateString()}
                </p>
            </div>
            ))}

          </div>
        )}

      </div>

    </div>
  );
}

export default ApplyHistory;